var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00976562 1C0.00976562 0.447715 0.457481 0 1.00977 0H17C17.5523 0 18 0.447715 18 1V12.3242C18 13.4288 17.1046 14.3242 16 14.3242H2C0.89543 14.3242 0 13.4288 0 12.3242V1.32422C0 1.2766 0.00332856 1.22976 0.00976562 1.18391V1ZM2 3.22375V12.3242H16V3.2241L11.1215 8.10261C9.94992 9.27418 8.05042 9.27418 6.87885 8.10261L2 3.22375ZM3.57232 1.96765H14.428L9.70728 6.68839C9.31675 7.07892 8.68359 7.07892 8.29306 6.68839L3.57232 1.96765Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c28c98fc.svg";
export { ForwardRef as ReactComponent };